<template>
  <div class="full-height">
    <table-con :showBreadCrumb='0'>
      <!-- 搜索 -->
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="title">{{$t('addr.addr4')}}</div>
            <div class="flex1">
              <el-input :placeholder="$t('addr.addr5')" clearable v-model="queryInfo.receiverName" size="big"
                        @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>
          <el-col :span="18" class="display-row">
            <div class="btn">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">{{$t('addr.addr6')}}</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">{{$t('addr.addr7')}}</el-button>
              <el-button class="search-btn btn-green" @click="addAdress">{{$t('addr.addr8')}}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 表格 -->
      <div slot="table" class="full-height display-col" style="padding:10px;height:100%">
        <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="tableData" border
                  height="550px">
          <el-table-column type="index" align="center" :label="$t('wzbg.wz6')" width="60"></el-table-column>
          <!-- 更多操作 -->
          <el-table-column label="操作" align="center" width="160">
            <template v-slot="scope">
              <div class="btn-row">
                <el-button class="list-btn btn-green" @click="edit(scope.row)">
                  {{$t('editor')}}
                </el-button>
                <el-button class="list-btn btn-blue" @click="drop(scope.row)">
                  {{$t('delete')}}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="addressNo" :label="$t('addr.addr13')">
            <template v-slot="scope">
              {{ scope.row.addressNo }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="defaultAddress" :label="$t('addr.addr14')">
            <template v-slot="scope">
              {{ scope.row.defaultAddress=='1'?$t('running.suspended1'):$t('running.suspended0') }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="receiverName" :label="$t('addr.addr15')" width="140">
            <template v-slot="scope">
              {{ scope.row.receiverName }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="receiverPhone" :label="$t('addr.addr16')" width="160">
            <template v-slot="scope">
              {{ scope.row.receiverPhone }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="receiverPhone" :label="$t('addr.addr17')" min-width="180">
            <template v-slot="scope">
              <div v-if="scope.row.provence">
                {{ scope.row.provenceName }}/
                {{ scope.row.cityName }}/
                {{ scope.row.areaName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="addressInfo" :label="$t('addr.addr18')" min-width="220">
            <template v-slot="scope">
              {{ scope.row.addressInfo }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="postcode" :label="$t('addr.addr19')">
            <template v-slot="scope">
              {{ scope.row.postcode }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="notes" :label="$t('addr.addr20')" min-width="180">
            <template v-slot="scope">
              {{ scope.row.notes }}
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
                       :page-sizes="[5, 10, 20, 50, 100, 200]" :pager-count="5" :page-size="queryInfo.pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </table-con>
    <!-- 遮罩层，新增地址 -->
    <el-dialog width="1050px" :visible.sync="showDialog" center @close="dialogClose('replyInfo')" :title="$t('addr.addr21')">
      <el-form :model="addressInfo" :rules="rules" ref="replyInfo" label-width="auto" class="demo-replyInfo">
        <div class="inputBox">
          <el-form-item prop="receiverName" :label="$t('addr.addr4')">
            <el-input v-model="addressInfo.receiverName" :placeholder="$t('addr.addr32')"></el-input>
          </el-form-item>
          <el-form-item prop="receiverPhone" :label="$t('addr.addr16')">
            <el-input v-model="addressInfo.receiverPhone" @input="handleInput" :placeholder="$t('addr.addr33')">
              <el-select v-model="select" slot="prepend" class="aabb">
                <el-option v-for="item in countryCodes" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </div>
        <el-form-item :label="$t('addr.addr26')" prop="address">
          <el-cascader style="width:100%" size="large" :placeholder="$t('addr.addr27')" v-model="addressInfo.address"
                       :options="options" :props="defaultParams" @change="addressChange">
          </el-cascader>

        </el-form-item>
        <el-form-item prop="postcode" :label="$t('addr.addr28')">
          <el-input v-model="addressInfo.postcode" :placeholder="$t('addr.addr28')"></el-input>
        </el-form-item>
        <!--        <el-form-item prop="addressNo" label="地址编号">-->
        <!--          <el-input v-model="addressInfo.addressNo" placeholder="地址编号"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item prop="addressInfo" :label="$t('addr.addr29')">
          <el-input type="textarea" :placeholder="$t('addr.addr30')" :rows="3" size="medium" v-model="addressInfo.addressInfo"
                    resize="none"></el-input>
        </el-form-item>
        <el-form-item :label="$t('addr.addr20')">
          <el-input type="textarea" v-model="addressInfo.notes" :rows="3" size="medium" :placeholder="$t('addr.addr20')"
                    resize="none"></el-input>
        </el-form-item>
        <el-form-item :label="$t('addr.addr31')">
          <el-switch inactive-value="0" active-value="1" v-model="addressInfo.defaultAddress">
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose('replyInfo')">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click="save('replyInfo')">{{$t('confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
import {countryCodes} from '@/assets/js/data'
export default {
  data () {
    return {
      select: '+81',
      countryCodes,
      userName: '',
      queryInfo: {
        type: '0',
        receiverName: '',
        pageSize: 10,
        pageNum: 1
      },
      tableData: [],
      showDialog: false,
      addressInfo: {
        type: '0',
        defaultAddress: '0',
        address: [],
      },
      rules: {
        receiverName: [
          { required: true, message: this.$t('addr.addr32'), trigger: 'blur' }
        ],
        receiverPhone: [
          { required: true, message: this.$t('addr.addr33'), trigger: 'blur' }
        ],
        addressInfo: [
          { required: true, message: this.$t('addr.addr34'), trigger: 'blur' }
        ],
        postcode: [
          { required: true, message: this.$t('addr.addr35'), trigger: 'blur' }
        ],
        addressNo: [
          { required: true, message: this.$t('addr.addr36'), trigger: 'blur' }
        ],
        address: [
          { type: 'array', required: true, message: this.$t('addr.addr37'), trigger: "blur" }
        ],
      },
      options: [],
      total: 0,
      defaultParams: {
        label: 'text',
        value: 'id',
        children: 'children',
        expandTrigger: 'click',
        checkStrictly: false
      },
    }
  },
  methods: {
    handleInput (val) {
      // this.addressInfo.receiverPhone = val.replace(/-/g, '')
      console.log(val,123)
    },
    getTreeData (data) {
      // 循环遍历json数据
      for (var i = 0; i < data.length; i++) {
        if (data[i].levelType !== '4') {
          if (data[i].children.length < 1) {
            // children若为空数组，则将children设为undefined
            data[i].children = undefined;
          } else {
            // children若不为空数组，则继续 递归调用 本方法
            this.getTreeData(data[i].children);
          }
        } else {
          continue
        }

      }
      return data;
    },
    async getAddressList_rp () {   //获取地址列表
      let url = 'cms/configAccountNumber/getAddressList';
      const { data: res } = await this.$http.get(url)
      this.options = this.getTreeData(res.data)
      console.log(res)
    },
    addressChange (arr) {
      // console.log(arr)
      console.log(CodeToText[arr[0]], CodeToText[arr[1]], CodeToText[arr[2]]);
      this.addressInfo.provence = CodeToText[arr[0]];
      this.addressInfo.city = CodeToText[arr[1]];
      this.addressInfo.area = CodeToText[arr[2]];
    },
    dialogClose (formName) {    //关闭新增/编辑弹窗
      this.$refs[formName].clearValidate();
      this.showDialog = false;
    },
    addAdress () {    //新建
      this.addressInfo = {
        type: '0',
        defaultAddress: '0',
        address: [],
      }
      this.select = '+81'
      this.showDialog = true;
    },
    save (formName) {         //保存
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.addressInfo)
          this.addressInfo.provence = this.addressInfo.address[0]
          this.addressInfo.city = this.addressInfo.address[1]
          this.addressInfo.area = this.addressInfo.address[2]
          this.addressInfo.receiverPhone = this.select + '-' + this.addressInfo.receiverPhone
          this.$http.post('cms/configAddressInfo/insertAndEdit', this.addressInfo).then(res => {
            if (res.data.code == 200) {
              this.$message({
                type: 'success',
                message: res.data.message
              })
              this.showDialog = false;
              this.getAddressList();
            } else {
              this.$message({
                type: 'warning',
                message: res.data.message
              })
            }
          })
        } else {
          this.$message.error(this.$t('addr.addr38'));
          return false;
        }
      });
    },
    drop (data) {   //删除
      this.$confirm(this.$t('addr.addr39'), {
        confirmButtonText: this.$t('submit'),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t('cancel'),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(_ => {
        this.$http.post('cms/configAddressInfo/insertAndEdit', {
          id: data.id,
          delFlag: '1'
        }).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: res.data.message
            })
            this.getAddressList();
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
      }).catch(_ => {
        this.$message({
          type: 'info',
          message: this.$t('addr.addr40')
        });
      })
    },
    edit (data) {     //编辑
      console.log('data===',data);
      let parts = data.receiverPhone.split('-');
      this.addressInfo = {
        id: data.id,
        type: data.type,
        receiverName: data.receiverName,
        // receiverPhone: data.receiverPhone.split("-")[1],
        receiverPhone: parts?.slice(1)?.join('-') || '',
        addressInfo: data.addressInfo,
        postcode: data.postcode,
        notes: data.notes,
        defaultAddress: data.defaultAddress,
        addressNo: data.addressNo,
        address: [parseInt(data.provence), parseInt(data.city), parseInt(data.area)]
      }
      this.select = data.receiverPhone.split("-")[0]
      console.log(this.addressInfo);
      this.showDialog = true;
    },
    queryInfoClear () {    //清空
      this.queryInfo.receiverName = '';
    },
    searchList () {    //查询
      this.getAddressList();
    },
    async getAddressList () {   //获取地址列表
      let url = 'cms/configAddressInfo/list';
      const { data: res } = await this.$http.get(url, { params: this.queryInfo })
      this.tableData = res.data.list;
      this.total = res.data.total;
      console.log(res)
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getAddressList();
    },
    handleCurrentChange (newPage) {    //分页
      this.queryInfo.pageNum = newPage;
      this.getAddressList();
    },
  },
  created () {
    this.getAddressList();
    this.getAddressList_rp();
    console.log(this.regionData);
  },
};
</script>

<style scoped lang='less'>
.title {
  width: 80px;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 10px;
}
.btn {
  text-align: right;
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding-right: 10px;
  float: right;
}
.search-btn {
  font-size: 17px;
}
.inputBox {
  width: 100%;
  display: flex;
  .el-form-item{
    width: 50%;
  }
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
/deep/ .breadcrumb-container {
  display: none;
}
.aabb{
  width: 100px!important;
  .el-input__inner{
    width: 100px;
  }
}
</style>